import React from "react";
import "./WhatsAppFloat.css";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppFloat() {

  const phone = "254728667665";

  const message =
    "Hello Zetech University. I would like to make an enquiry.";

  return (

    <a
      href={`https://wa.me/${phone}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="zetech-whatsapp-float"
      aria-label="Chat on WhatsApp"
    >

      <span className="zetech-whatsapp-tooltip">

        Chat With Us

      </span>

      <FaWhatsapp />

    </a>

  );

}